import {
  Entity,
  PrimaryGeneratedColumn,
  Column,
  CreateDateColumn,
  UpdateDateColumn,
  ManyToOne,
  JoinColumn,
} from 'typeorm';
import { IsOptional, IsInt, IsDate } from 'class-validator';
import {
  PlacentaLocalizacao,
  NormalAlterado,
  ApresentacaoFetal,
  SexoBebe,
} from '../types';
import { Usuario } from './Usuario';
import { Paciente } from './Paciente';
import { Gestacao } from './Gestacao';

@Entity({ name: 'ultrassons' })
export class Ultrassom {
  @PrimaryGeneratedColumn()
  @IsOptional()
  @IsInt()
  id?: number;

  @Column()
  @IsInt()
  paciente_id: number;

  @Column()
  @IsOptional()
  gestacao_id: number;

  @Column()
  @IsDate()
  data_ultrassom: Date;

  @Column()
  @IsOptional()
  ig_semanas?: number | null;

  @Column()
  @IsOptional()
  ig_dias?: number | null;

  @Column({
    type: 'enum',
    enum: PlacentaLocalizacao,
  })
  @IsOptional()
  placenta_localizacao?: PlacentaLocalizacao | null;

  @Column()
  @IsOptional()
  placenta_grau?: number | null;

  @Column()
  @IsOptional()
  observacoes?: string | null;

  // BEBES
  @Column()
  @IsOptional()
  ila1?: number | null;

  @Column({
    type: 'enum',
    enum: NormalAlterado,
  })
  @IsOptional()
  doppler1?: NormalAlterado | null;

  @Column()
  @IsOptional()
  peso_gramas1?: number | null;

  @Column({
    type: 'enum',
    enum: NormalAlterado,
  })
  @IsOptional()
  morfologia1?: NormalAlterado | null;

  @Column({
    type: 'enum',
    enum: ApresentacaoFetal,
  })
  apres_fetal1?: ApresentacaoFetal | null;

  @Column({
    type: 'enum',
    enum: SexoBebe,
  })
  @IsOptional()
  sexo1?: SexoBebe | null;

  @Column()
  @IsOptional()
  ila2?: number | null;

  @Column({
    type: 'enum',
    enum: NormalAlterado,
  })
  @IsOptional()
  doppler2?: NormalAlterado | null;

  @Column()
  @IsOptional()
  peso_gramas2?: number | null;

  @Column({
    type: 'enum',
    enum: NormalAlterado,
  })
  @IsOptional()
  morfologia2?: NormalAlterado | null;

  @Column({
    type: 'enum',
    enum: ApresentacaoFetal,
  })
  apres_fetal2?: ApresentacaoFetal | null;

  @Column({
    type: 'enum',
    enum: SexoBebe,
  })
  @IsOptional()
  sexo2?: SexoBebe | null;

  @CreateDateColumn()
  created?: Date;

  @Column()
  @IsOptional()
  created_by?: number | null;

  @UpdateDateColumn()
  updated?: Date;

  @Column()
  @IsOptional()
  updated_by?: number | null;

  // RELATIONS
  @ManyToOne(() => Paciente)
  @JoinColumn({ name: 'paciente_id' })
  paciente?: Paciente;

  @ManyToOne(() => Gestacao)
  @JoinColumn({ name: 'gestacao_id' })
  gestacao?: Gestacao;

  @ManyToOne(() => Usuario, { eager: true })
  @JoinColumn({ name: 'created_by' })
  usuario_created_by?: Usuario;

  @ManyToOne(() => Usuario, { eager: true })
  @JoinColumn({ name: 'updated_by' })
  usuario_updated_by?: Usuario;
}
